import React from "react";
import { Row, Col } from "react-bootstrap";

const ErrorMessage = (props) => {
  const { error } = props;

  const displayError =
    error && error.message ? (
      <Row>
        <Col>
          <span className="error" role="alert">ERROR:  {error.message}</span>
        </Col>
      </Row>
    ) : null;

  return displayError;
};

export default ErrorMessage;
